// extracted by mini-css-extract-plugin
export var aggregationCell = "_63-k";
export var aggregationRow = "_63-j";
export var borderlessSpinnerContainer = "_63-3";
export var closeIcon = "_63-c";
export var columnHeaderSurface = "_63-8";
export var columnHeaderSurfaceDragOverlay = "_63-s";
export var columnHeaderSurfaceResizing = "_63-p";
export var contextMenuAnchor = "_63-1";
export var draggableColumnHeader = "_63-q";
export var draggableColumnHeaderOverlay = "_63-r";
export var expandIcon = "_63-d";
export var expanded = "_63-e";
export var filterDropdown = "_63-f";
export var filterDropdownDivider = "_63-a";
export var filterDropdownHeader = "_63-i";
export var filterDropdownItem = "_63-h";
export var filterDropdownModal = "_63-g _63-f";
export var filterItem = "_63-9";
export var normalCellWithAdjustableBorder = "_63-b";
export var pinButtonContainer = "_63-l";
export var pinIcon = "_63-m";
export var pinIconActive = "_63-n";
export var spinner = "_63-0";
export var spinnerContainer = "_63-2";
export var tableContainer = "_63-4";
export var tableContentDraggingColumns = "_63-7";
export var tableContentInner = "_63-6";
export var tableContentWrapper = "_63-5";
export var viewButtonContainer = "_63-o";